module.exports = __webpack_public_path__ + "static/media/universities-icon-4.fd769e0c.svg";